module.exports = __webpack_public_path__ + "img/029-file.bc598ea9.png";